import React from 'react';

function AccPasswordResetPage() {
    return <div>AccPasswordResetPage</div>;
}

export default AccPasswordResetPage;
